import { datadogRum } from '@datadog/browser-rum';
import { useCallback } from 'react';

export function useDatadogRumActions() {
  const setUser = useCallback((user: { id?: string; name?: string; email?: string; role?: string }) => {
    if (datadogRum.getInitConfiguration()) {
      datadogRum.setUserProperty('id', user.id);
      datadogRum.setUserProperty('name', user.name);
      datadogRum.setUserProperty('email', user.email);
      if (user.role) {
        datadogRum.setGlobalContextProperty('user.role', user.role);
      }
    }
  }, []);

  const addAction = useCallback((name: string, context?: Record<string, any>) => {
    if (datadogRum.getInitConfiguration()) {
      datadogRum.addAction(name, context);
    }
  }, []);

  const addError = useCallback((error: Error, context?: Record<string, any>) => {
    if (datadogRum.getInitConfiguration()) {
      datadogRum.addError(error, context);
    }
  }, []);

  const setGlobalContext = useCallback((attribute: string, value: any) => {
    if (datadogRum.getInitConfiguration()) {
      datadogRum.setGlobalContextProperty(attribute, value);
    }
  }, []);

  const removeGlobalContext = useCallback((attribute: string) => {
    if (datadogRum.getInitConfiguration()) {
      datadogRum.removeGlobalContextProperty(attribute);
    }
  }, []);

  const startView = useCallback((name?: string) => {
    if (datadogRum.getInitConfiguration()) {
      datadogRum.startView(name);
    }
  }, []);

  return {
    setUser,
    addAction,
    addError,
    setGlobalContext,
    removeGlobalContext,
    startView,
  };
}